import { createRouter, createWebHistory } from 'vue-router'

import Landing from '@/views/landing/Landing.vue'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        if (to.hash) return { el: to.hash, behavior: 'smooth', top: 96 }
        return { top: 0 }
    },
    routes: [
        {
            // Single-page site: statically imported so the first paint needs no
            // second chunk round-trip.
            path: '/',
            name: 'landing',
            component: Landing,
            meta: { layout: 'Blank', requiresAuth: false },
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/',
        },
    ],
})

export default router
